import React, { useEffect, ComponentProps } from 'react';
import { useAuthentication } from '../../../Login/hooks/useAuthentication';
import {
    ProgressBreadcrumbList,
    ProgressBreadcrumbListTheme,
    ProgressBreadcrumbCompletedDisplayStyle,
    ProgressBreadcrumb,
} from '@apply/components';
import '../../scss/_applicationEntrySidebar.scss';

type ProgressBreadcrumbProps = ComponentProps<typeof ProgressBreadcrumb>;
export interface ApplicationEntrySidebarProps {
    crumbs: ProgressBreadcrumbProps[];
    currentCrumb: number;
    printMode?: boolean;
}

export const ApplicationEntrySidebar: React.FC<ApplicationEntrySidebarProps> = ({ crumbs, currentCrumb }) => {
    const { authentication, isAuthenticated } = useAuthentication();

    useEffect(() => {
        if (!authentication) {
            return;
        }

        if (!isAuthenticated) {
            if (!window.location.pathname.startsWith('/login')) {
                window.location.href = '/login';
            }
        }
    }, [authentication, isAuthenticated]);

    return (
        <>
            <div className='applicationEntrySidebar'>
                <div className='applicationEntrySidebar-contentWrapper'>
                    <div className='applicationEntrySidebar-logo'>
                        <img
                            src='/assets/img/logo.webp.html'
                            alt='Builder Finance'
                            width='116px'
                        />
                    </div>
                    <div className='applicationEntrySidebar-descriptor'>Apply</div>
                    <div className='applicationEntrySidebar-progressBreadcrumb-vertical'>
                        <ProgressBreadcrumbList
                            id='applicationEntrySidebarVerticalBreadcrumb'
                            theme={ProgressBreadcrumbListTheme.Blue}
                            activeCrumbNumber={currentCrumb}
                            crumbs={crumbs}
                            completedCrumbDisplayStyle={ProgressBreadcrumbCompletedDisplayStyle.Checkmark}
                        />
                    </div>
                </div>
            </div>
        </>
    );
};
